import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  DialogActions,
  useTheme,
  Stepper,
  Step,
  StepLabel as MaterialStepLabel,
  Box,
  styled,
  Button,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { Chevron } from "components";
import { ActivateForm } from "./ActivateForm";
import { ConfirmLicenseInfo } from "./ConfirmLicenseInfo";
const StepLabel = styled(MaterialStepLabel)(() => ({
  width: "130px",
  "&& .MuiStepLabel-iconContainer > .MuiStepIcon-root": {
    width: "28px",
    height: "28px",
  },
  "&& .MuiStepLabel-iconContainer > .MuiStepIcon-root > circle": {
    color: "#D719204D",
    stroke: "#D71920",
    strokeWidth: "1px",
    r: "11",
  },
  "&& .MuiStepLabel-iconContainer > .MuiStepIcon-root > text": {
    fill: "#D71920",
  },
  "&& .MuiStepLabel-iconContainer > .Mui-active > circle": {
    color: "#D71920",
    stroke: "#D71920",
    strokeWidth: "1px",
    r: "11",
  },
  "&& .MuiStepLabel-iconContainer > .Mui-active > text": {
    fill: "#FFFFFF",
    fontWeight: "bold",
  },
  "&& .MuiStepLabel-labelContainer > .MuiStepLabel-label": {
    font: "normal normal normal 13px/14px Ubuntu",
    color: "#999999",
  },
  "&& .MuiStepLabel-labelContainer > .Mui-active": {
    font: "normal normal bold 13px/14px Ubuntu",
    color: "#241540",
  },
}));

export const ActivateDialog = ({ state, dispatchers }) => {
  const theme = useTheme();
  const { activateStep, isActivateDialogOpen, activateLoadingStatus } = state;

  return (
    <Dialog
      open={isActivateDialogOpen}
      fullWidth={true}
      onClose={() => {
        dispatchers.setActivateDialogVisible(false);
      }}
    >
      <DialogTitle component="div">
        <Typography
          variant="h5"
          sx={{
            marginTop: theme.spacing(2),
            textAlign: "center",
            font: "normal normal normal 30px/38px Ubuntu",
          }}
        >
          License Registration
        </Typography>
        <IconButton
          sx={{ position: "absolute", top: 5, right: 5 }}
          onClick={() => {
            dispatchers.setActivateDialogVisible(false);
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ margin: "0 auto", width: "55%" }}>
          <Stepper
            activeStep={activateStep}
            alternativeLabel
            sx={{ marginTop: theme.spacing(4) }}
          >
            <Step completed={false}>
              <StepLabel>Registration Code</StepLabel>
            </Step>
            <Step completed={false}>
              <StepLabel>Verification</StepLabel>
            </Step>
          </Stepper>
        </Box>
        {activateLoadingStatus ? (
          <Box sx={{ marginTop: theme.spacing(4), textAlign: "center" }}>
            <CircularProgress />
          </Box>
        ) : activateStep === 0 ? (
          <ActivateForm
            state={state}
            setLicenseKey={dispatchers.setLicenseKey}
          />
        ) : (
          <ConfirmLicenseInfo state={state} />
        )}
      </DialogContent>
      <DialogActions
        sx={{ justifyContent: "center", marginBottom: theme.spacing(3) }}
      >
        {activateStep === 0 ? (
          <Button
            sx={{
              font: "normal normal normal 16px/18px Ubuntu",
              paddingTop: theme.spacing(1),
              paddingBottom: theme.spacing(1),
              paddingLeft: theme.spacing(3),
              paddingRight: theme.spacing(3),
            }}
            variant="contained"
            color="secondary"
            endIcon={<Chevron width={20} height={20} />}
            onClick={() => dispatchers.getLicenseInfo(state.licenseKey)}
            disabled={activateLoadingStatus}
          >
            Next
          </Button>
        ) : (
          <>
            <Button
              sx={{
                font: "normal normal normal 16px/18px Ubuntu",
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3),
                broder: "1px solid #241540",
                color: "#241540",
              }}
              variant="outlined"
              startIcon={
                <Chevron
                  width={20}
                  height={20}
                  style={{
                    stroke: "#241540",
                    transform: "translate(0px, 0px) rotate(180deg)",
                  }}
                />
              }
              onClick={() => dispatchers.clean()}
              disabled={activateLoadingStatus}
            >
              Back
            </Button>
            <Button
              sx={{
                font: "normal normal normal 16px/18px Ubuntu",
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3),
              }}
              variant="contained"
              color="secondary"
              endIcon={<Chevron width={20} height={20} />}
              onClick={() => {
                dispatchers.activateLicense(state.licenseKey);
                dispatchers.setActivateDialogVisible(false);
              }}
              disabled={activateLoadingStatus}
            >
              Submit
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};
ActivateDialog.propTypes = {
  state: PropTypes.object.isRequired,
  dispatchers: PropTypes.object.isRequired,
};
export default ActivateDialog;
